<template>
  <div id="app">
    <!-- <header v-if="$route.meta.showNav" class="header">
      <div class="header-content">
        <div class="left">
          <router-link to="/" class="logo">
            <span>重庆卫生人才网</span>
          </router-link>
        </div>
        <div class="search">
          <input type="text" placeholder="请输入关键词" />
          <button class="search-btn">搜索</button>
        </div>
        <div class="right"> -->
          <!-- <router-link to="/register" class="nav-link">免费注册</router-link> -->
          <!-- <div class="nav-link pointer" @click="toRegister">免费注册</div> -->
          <!-- <router-link to="/login" class="nav-link login-btn"
            >用户登录</router-link
          > -->
          <!-- <div class="nav-link login-btn pointer" @click="toLogin">
            用户登录
          </div>
        </div>
      </div>
    </header> -->
    <router-view />
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        title="网上报名系统身份信息完善提示"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose">
      <el-alert
          :closable="false"
          type="warning"
          description="系统需核验您的真实身份，首次登录请补充填写本人真实姓名及身份证号码，完成信息采集后即可正常使用。"
          show-icon>
      </el-alert>
      <el-form style="margin-top: 20px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="ruleForm.idCard"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
<!--    <el-button @click="resetForm('ruleForm')">取 消</el-button>-->
    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import MainLayout from '@/components/layout/MainLayout.vue';
import {getToken, removeToken, setToken} from "@/utils/auth";
import store from "@/store";

export default {
  name: 'BasicInfo',
  components: {
    MainLayout,
  },
  data() {
    return {
      ruleForm:{
        name:'',
        idCard:''
      },
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
      }
    };
  },
  computed:{
    dialogVisible:{
      get(){
        return this.$store.state.showValidate
      },
      set(val){
        this.$store.commit('CHANGE_VALIDATE',val)
      }
    }
  },
  watch: {},
  methods: {
    toLogin() {
      //console.log('path', this.$route.path);
      localStorage.setItem('path', JSON.stringify(this.$route.path));
      localStorage.setItem('pathName', JSON.stringify(this.$route.name));
      this.$router.push('/login');
    },
    toRegister() {
      window.open('https://www.cqwsrc.cn/hrcms/rcfwSingleRegister.html');
    },
    handleClose(){

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = new URLSearchParams(window.location.search);
          // 获取 token 参数
          const token = params.get('token');
          const userName = params.get('userName');
          const userId = params.get('userId');
          const phone = params.get('phone');

          // 创建 userInfo 对象
          const userInfo = {
            token: token || null,
            username: this.ruleForm.name || null,
            userName: this.ruleForm.name || null,
            userId: userId || null,
            phone: phone || null,
            idCard: this.ruleForm.idCard || null,
            updateFlag:true
          };
          if (token) {//有token应该是卫生中心过来的
            // 清除旧token
            if (getToken()) {
              removeToken();
            }
            setToken(token);
            if (localStorage.getItem('token')) {
              localStorage.removeItem('token');
            }
            localStorage.setItem('token', token);
            // 将 userInfo 对象存储到 localStorage
            if (localStorage.getItem('userInfo')) {
              localStorage.removeItem('userInfo');
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            console.log('userInfo-------', localStorage.getItem('userInfo'));

            store.commit('SET_USERINFO', JSON.stringify(userInfo));

            //同步数据
            store.dispatch('getUserInfoVar', userInfo);
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header {
  background-color: #333;
  color: white;
  padding: 10px 0;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.left .logo {
  color: white;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
}

.search {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search input {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  width: 300px;
}

.search-btn {
  background-color: #666;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
}

.search-btn:hover {
  background-color: #555;
}

.right {
  display: flex;
  gap: 20px;
  align-items: center;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
}

/* .login-btn {
  background-color: #e74c3c;
  padding: 6px 15px;
  border-radius: 4px;
}

.login-btn:hover {
  background-color: #c0392b;
} */

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 10px;
  }

  .search input {
    width: 200px;
  }

  .right {
    margin-top: 10px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>
